// import {specialprice } from "../../services/specialPrice.servise";
import { SPECIAL_PRICE } from "./actionsTypes";
import { specialprice } from "../../services/specialPrice.servise";
import { apiStart, apiError, apiSuccess } from "./apiActions";


export function getSpecialPrice(statusValue: any, isFilterByDate: any, fromDate: any, toDate: any, search: any, page: any) {
    return async (dispatch: any) => {
        dispatch(apiStart(SPECIAL_PRICE.GET_SPECIALPRICE_LIST_FETCHING));
        try {
            const response = await specialprice.getSpecialPrice(statusValue, isFilterByDate, fromDate, toDate, search, page);
            dispatch(apiSuccess(SPECIAL_PRICE.GET_SPECIALPRICE_LIST_SUCCESS, response));
            return response || [];
        } catch (error) {
            dispatch(apiError(SPECIAL_PRICE.GET_SPECIALPRICE_LIST_ERROR, error));
            return error;
        }
    };
}

export function userAccesssRestriction(data: any) {
    return async (dispatch: any) => {
        dispatch(apiStart(SPECIAL_PRICE.POST_BACK_BUTTON_RESTRICTION_FETCHING));
        try {
            const response = await specialprice.userAccesssRestriction(data);
            dispatch(apiSuccess(SPECIAL_PRICE.POST_BACK_BUTTON_RESTRICTION_SUCCESS, response));
            return response || [];
        } catch (error) {
            dispatch(apiError(SPECIAL_PRICE.POST_BACK_BUTTON_RESTRICTION_ERROR, error));
            return error;
        }
    };
}

export function getSpecialPriceStatus() {
    return async (dispatch: any) => {
        dispatch(apiStart(SPECIAL_PRICE.GET_SPECIALPRICE_STATUS_FETCHING));
        try {
            const response = await specialprice.getSpecialPriceStatus()
            dispatch(apiSuccess(SPECIAL_PRICE.GET_SPECIALPRICE_STATUS_SUCCES, response));
            return response || [];
        } catch (error) {
            dispatch(apiError(SPECIAL_PRICE.GET_SPECIALPRICE_STATUS_ERROR, error));
            return error;
        }
    }
}

export function viewSpecialPriceAPI(id: any, name: any) {
    return async (dispatch: any) => {
        dispatch(apiStart(SPECIAL_PRICE.VIEW_SPECIALPRCIEREQUEST_FETCHING));
        try {
            const response = await specialprice.viewSpecialPriceAPI(id, name)
            dispatch(apiSuccess(SPECIAL_PRICE.VIEW_SPECIALPRICEREQUEST_SUCCESS, response));
            return response || [];
        } catch (error) {
            dispatch(apiError(SPECIAL_PRICE.VIEW_SPECIALRICEREQUEST_ERROR, error));
            return error;
        }
    }
}

export function addComment(id: any, uid: any, addedBy: any, addedName: any, addedRole: any, comment: any) {
    return async (dispatch: any) => {
        dispatch(apiStart(SPECIAL_PRICE.ADDCOMMENT_SPECIALPRICE_FETCHING));
        try {
            const response = await specialprice.addComment(id, uid, addedBy, addedName, addedRole, comment)
            dispatch(apiSuccess(SPECIAL_PRICE.ADDCOMMENT_SPECIALPRICE_SUCCESS, response));
            return response || [];
        } catch (error) {
            dispatch(apiError(SPECIAL_PRICE.ADDCOMMENT_SPECIALPRICE_ERROR, error));
            return error;
        }
    }
}

export function getCommentPart(id: any, uid: any, sapCustomerId: any, role: string = 'pricing_team') {
    return async (dispatch: any) => {
        dispatch(apiStart(SPECIAL_PRICE.GETCOMMENTPART_SPECIALPRICE_FETCHING));
        try {
            const response = await specialprice.getCommentPart(id, uid, sapCustomerId, role)
            dispatch(apiSuccess(SPECIAL_PRICE.GETCOMMENTPART_SPECIALPRICE_SUCCESS, response));
            return response || [];
        } catch (error) {
            dispatch(apiError(SPECIAL_PRICE.GETCOMMENTPART_SPECIALPRICE_ERROR, error));
            return error;
        }
    }
}

// export function addCommentTotal(id: any, name: any) {
//     return async (dispatch: any) => {
//         dispatch(apiStart(SPECIAL_PRICE.ADDCOMMENT_SPECIALPRICE_FETCHING));
//         try {
//             const response = await specialprice.viewSpecialPriceAPI(id, name)
//             dispatch(apiSuccess(SPECIAL_PRICE.ADDCOMMENT_SPECIALPRICE_SUCCESS, response));
//             return response || [];
//         } catch (error) {
//             dispatch(apiError(SPECIAL_PRICE.ADDCOMMENT_SPECIALPRICE_ERROR, error));
//             return error;
//         }
//     }
// }

export function postForwardRequestToKam(data: any) {
    return async (dispatch: any) => {
        dispatch(apiStart(SPECIAL_PRICE.POST_FORWARD_TO_KAM_STATUS_FETCHING));
        try {
            const response = await specialprice.postForwardRequestToKam(data)
            dispatch(apiSuccess(SPECIAL_PRICE.POST_FORWARD_TO_KAM_STATUS_SUCCESS, response));
            return response || [];
        } catch (error) {
            dispatch(apiError(SPECIAL_PRICE.POST_FORWARD_TO_KAM_STATUS_ERROR, error));
            return error;
        }
    }
}

export function addCommentTotal(id: any, uid: any, addedBy: any, addedName: any, addedRole: any, comment: any) {
    return async (dispatch: any) => {
        dispatch(apiStart(SPECIAL_PRICE.ADDCOMMENTTOTAL_SPECIALPRICE_FETCHING));
        try {
            const response = await specialprice.addCommentAll(id, uid, addedBy, addedName, addedRole, comment)
            dispatch(apiSuccess(SPECIAL_PRICE.ADDCOMMENT_SPECIALPRICE_SUCCESS, response));
            return response || [];
        } catch (error) {
            dispatch(apiError(SPECIAL_PRICE.ADDCOMMENTTOTAL_SPECIALPRICE_ERROR, error));
            return error;
        }
    }
}

export function postSaveFormData(data: any) {
    return async (dispatch: any) => {
        dispatch(apiStart(SPECIAL_PRICE.SAVE_FORM_API_FETCHING));
        try {
            const response = await specialprice.postSaveFormData(data)
            dispatch(apiSuccess(SPECIAL_PRICE.SAVE_FORM_API_SUCCESS, response));
            return response || [];
        } catch (error) {
            dispatch(apiError(SPECIAL_PRICE.SAVE_FORM_API_ERROR, error));
            return error;
        }
    }
}

export function rejectPart(data: any) {
    return async (dispatch: any) => {
        dispatch(apiStart(SPECIAL_PRICE.REJECT_BY_PART_API_FETCHING));
        try {
            const response = await specialprice.rejectPart(data)
            dispatch(apiSuccess(SPECIAL_PRICE.REJECT_BY_PART_API_SUCCESS, response));
            return response || [];
        } catch (error) {
            dispatch(apiError(SPECIAL_PRICE.REJECT_BY_PART_API_ERROR, error));
            return error;
        }
    }
}

export function rejectRequest(data: any) {
    return async (dispatch: any) => {
        dispatch(apiStart(SPECIAL_PRICE.REJECT_REQUEST_API_FETCHING));
        try {
            const response = await specialprice.rejectRequest(data)
            dispatch(apiSuccess(SPECIAL_PRICE.REJECT_REQUEST_API_SUCCESS, response));
            return response || [];
        } catch (error) {
            dispatch(apiError(SPECIAL_PRICE.REJECT_REQUEST_API_ERROR, error));
            return error;
        }
    }
}

export function getCommentTotal(id: any, sapCustomerId: any) {
    return async (dispatch: any) => {
        dispatch(apiStart(SPECIAL_PRICE.GETCOMMENTTOTAL_SPECIALPRICE_FETHCING));
        try {
            const response = await specialprice.getCommentPartTotal(id, sapCustomerId)
            dispatch(apiSuccess(SPECIAL_PRICE.GETCOMMENTTOTAL_SPECIALPRICE_SUCCESS, response));
            return response || [];
        } catch (error) {
            dispatch(apiError(SPECIAL_PRICE.GETCOMMENTTOTAL_SPECIALPRICE_ERROR, error));
            return error;
        }
    }
}


export function getComment(id: any, sapCustomerId: any) {
    return async (dispatch: any) => {
        dispatch(apiStart(SPECIAL_PRICE.GETCOMMENTTOTAL_SPECIALPRICE_FETHCING));
        try {
            const response = await specialprice.getCommentPartTotal(id, sapCustomerId)
            dispatch(apiSuccess(SPECIAL_PRICE.GETCOMMENTTOTAL_SPECIALPRICE_SUCCESS, response));
            return response || [];
        } catch (error) {
            dispatch(apiError(SPECIAL_PRICE.GETCOMMENTTOTAL_SPECIALPRICE_ERROR, error));
            return error;
        }
    }
}

export function checkandavaliabilityApi(B2bEnquiryId: any, data: any) {
    return async (dispatch: any) => {
        dispatch(apiStart(SPECIAL_PRICE.CHECK_AVALIABLILITY_API_FETCHING));
        try {
            const response = await specialprice.checkandavaliabilityApi(B2bEnquiryId, data)
            dispatch(apiSuccess(SPECIAL_PRICE.CHECK_AVALIABLILITY_API_SUCCESS, response));
            return response || [];
        } catch (error) {
            dispatch(apiError(SPECIAL_PRICE.CHECK_AVALIABLILITY_API_ERROR, error));
            return error;
        }
    }
}

export function checkAvailabilityResetData() {
    return async (dispatch: any) => {
        return dispatch({type:SPECIAL_PRICE.CHECK_AVALIABLILITY_RESET_DATA })
    }
}

export function storeOrderNumberPT(orderNumber: any) {
    return async (dispatch: any) => {
        return dispatch(apiSuccess(SPECIAL_PRICE.STORE_ORDER_NUMBER, orderNumber));
    }
}

export function storeReopenedDetails(data: any) {
    return async (dispatch: any) => {
        return dispatch(apiSuccess(SPECIAL_PRICE.STORE_DETAILS_REOPENED, data));
    }
}

export function statusReopened(data: any) {
    return async (dispatch: any) => {
        dispatch(apiStart(SPECIAL_PRICE.POST_STATUS_REOPENED_API_FETCHING));
        try {
            const response = await specialprice.statusReopened(data)
            dispatch(apiSuccess(SPECIAL_PRICE.POST_STATUS_REOPENED_API_SUCCESS, response));
            return response || [];
        } catch (error) {
            dispatch(apiError(SPECIAL_PRICE.POST_STATUS_REOPENED_API_ERROR, error));
            return error;
        }
    }
}

export function requestCorrection(id: any) {
    return async (dispatch: any) => {
        dispatch(apiStart(SPECIAL_PRICE.GET_REQUEST_CORRECTION__PRCING_FETCHING));
        try {
            const response = await specialprice.getRequestCorrection(id)
            dispatch(apiSuccess(SPECIAL_PRICE.GET_REQUEST_CORRRECTION_PRICING_SUCCES, response));
            return response || [];
        } catch (error) {
            dispatch(apiError(SPECIAL_PRICE.GET_REQUEST_CORRECTION_PRICING_ERROR, error));
            return error;
        }
    }
}